import React from 'react';
import { authRoles } from 'app/auth';

const UsersConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	auth: authRoles.superAdmin,
	routes: [
		{
			path: '/users',
			component: React.lazy(() => import('./Users'))
		}
	]
};

export default UsersConfig;
